import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = 'https://roshi-chat.herokuapp.com'

export const GetJobTracking = async ( userId, search = '' ) => {
    const res = await axios.get(`${URL}/jobtracking/all`, {
        params: {
            id: userId,
            search
        }
    })
    return res.data;
}

export const AddJobTracking = async ( form ) => {
    const res = await axios.post(`${URL}/jobtracking/add`, form)
    return res.data;
}

export const DeleteTracking = async (id) => {
    const res = await axios.delete(`${URL}/jobtracking/${id}`)
    return res.data;
}
export const UpdateTracking = async (form) => {
    const res = await axios.put(`${URL}/jobtracking/update`, form)
    return res.data;
}
